export const allowedPageSizes = [ 10, 20, 30 ];
export const pageFormats = [ 'csv', 'xlsx', 'pdf' ];